import { defineMessages } from "react-intl"

const moment = require("moment")
const { isEmpty } = require("lodash")

const messages = defineMessages({
  textElementErrorTooSmall: {
    id: "form.element.text.error.tooSmall",
    defaultMessage: "Field must have at least {minLength} characters"
  },
  textElementErrorTooBig: {
    id: "form.element.text.error.tooBig",
    defaultMessage: "Field must have at most {maxLength} characters"
  },
  addressElementErrorCityMissing: {
    id: "form.element.address.error.cityMissing",
    defaultMessage: "City is required"
  },
  addressElementErrorPostalCodeMissing: {
    id: "form.element.address.error.postalCodeMissing",
    defaultMessage: "Postal Code is required"
  },
  addressElementErrorCountryMissing: {
    id: "form.element.address.error.countryMissing",
    defaultMessage: "Country is required"
  },
  mailElementError: {
    id: "form.element.mail.error",
    defaultMessage: "Invalid mail address"
  },
  phoneElementError: {
    id: "form.element.phone.error",
    defaultMessage: "Invalid phone number"
  },
  dateElementError: {
    id: "form.element.date.error",
    defaultMessage:
      "Invalid date: The date must be between {minDateFormatted} and {maxDateFormatted}."
  },
  numberElementErrorPositiveOnly: {
    id: "form.element.number.error.positiveOnly",
    defaultMessage: "Field must be positive"
  },
  numberElementErrorTooSmall: {
    id: "form.element.number.error.tooSmall",
    defaultMessage: "Field must be equal or greater than {minValue}"
  },
  numberElementErrorTooBig: {
    id: "form.element.number.error.tooBig",
    defaultMessage: "Field must be equal or smaller than {maxValue}"
  }
})

/**
 * This file holds validation value for every form element types
 * Those functions take as parameters:
 * - element (the current element to be validated, hold every parameters of the element)
 * - value (the current value to be validated)
 * - errors (current error object, used to modify existing errors if needed)
 * - intl (intl object, used to format the returned strings)
 * When there are no error, the function should return null
 * */

function validateTextField(el, value, _, intl) {
  const { data } = el
  const minLength = data.minLength.value
  const maxLength = data.maxLength.value
  const { formatMessage: format } = intl

  if (minLength === 0 && maxLength === 0) {
    return null
  }

  if (value.length < minLength) {
    return format(messages.textElementErrorTooSmall, { minLength })
  }

  if (value.length > maxLength) {
    return format(messages.textElementErrorTooBig, { maxLength })
  }

  return null
}

function validateAddress(el, value, _, intl) {
  const { data } = el
  const { formatMessage: format } = intl
  const cityRequired = data.cityRequired.value
  const postalCodeRequired = data.postalCodeRequired.value
  const countryRequired = data.countryRequired.value

  const errors = {}
  if (cityRequired && !value.city) {
    errors.city = format(messages.addressElementErrorCityMissing)
  }
  if (postalCodeRequired && !value.postalCode) {
    errors.postalCode = format(messages.addressElementErrorPostalCodeMissing)
  }
  if (countryRequired && !value.country) {
    errors.country = format(messages.addressElementErrorCountryMissing)
  }

  if (isEmpty(errors)) {
    return null
  }
  return errors
}

function validatePhone(/* _, value */) {
  return null
  // if (!value) {
  //   return null
  // }
  //
  // // Phone regex - 10 digits only
  // if (!/^[0-9]{10}$/i.test(value)) {
  //   // return format(messages.phoneElementError)
  //   // Pour l'instant, ce code est commenté pour permettre à tout le monde de mettre un numéro de téléphone étranger
  //   // TODO: Il faudra mettre à jour ce code avec le préfixe de téléphone demandé dans le Select de Pays
  //   return null
  // }
  //
  // return null
}

function validateMail(_, value, __, intl) {
  if (!value) {
    return null
  }
  const { formatMessage: format } = intl

  // Mail regex
  if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
    return format(messages.mailElementError)
  }
  return null
}

function validateDate(el, value, _, intl) {
  const { data } = el
  const { formatMessage: format } = intl
  const dateFormat = "DD/MM/YYYY"
  const minDate = moment(data.minDate.value, dateFormat)
  const maxDate = moment(data.maxDate.value, dateFormat)
  const minDateFormatted = minDate.format(dateFormat)
  const maxDateFormatted = maxDate.format(dateFormat)

  if (!value) {
    return null
  }

  const valueDate = moment(value)
  if (valueDate.isBefore(minDate) || valueDate.isAfter(maxDate)) {
    return format(messages.dateElementError, {
      minDateFormatted,
      maxDateFormatted
    })
  }

  return null
}

function validateNumber(el, value, _, intl) {
  const { data } = el
  const { formatMessage: format } = intl
  const positiveOnly = data.positiveOnly.value
  const minValue = data.minValue.value
  const maxValue = data.maxValue.value

  const valueNb = parseInt(value, 10)

  if (!valueNb) {
    return null
  }

  if (positiveOnly && valueNb < 0) {
    return format(messages.numberElementErrorPositiveOnly)
  }

  if (valueNb < minValue) {
    return format(messages.numberElementErrorTooSmall, { minValue })
  }

  if (valueNb > maxValue) {
    return format(messages.numberElementErrorTooBig, { maxValue })
  }

  return null
}

export default {
  text: validateTextField,
  address: validateAddress,
  phone: validatePhone,
  mail: validateMail,
  date: validateDate,
  number: validateNumber,
  freeText: undefined,
  matrixSelection: undefined
}
